import { LoadMore } from "../../../shared/components/LoadMore/LoadMore";
import { Item } from "../../../shared/types/item";
import { Dispatch, SetStateAction } from "react";
import { SearchProposals } from "./search-proposals/SearchProposals/SearchProposals";
import { SearchNoResults } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/SearchNoResults/SearchNoResults";
import { SearchResultsTitle } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/SearchResultsTitle/SearchResultsTitle";
import { SearchResultsListView } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/SearchResultsListView/SearchResultsListView";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";

interface SearchResultsPresentationProps {
  proposals: string[];
  items: Item[];
  loading: boolean;
  totalCount: number;
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  setSearchHistory: (value: string[]) => void;
  searchHistory: string[];
  handleLoadMoreClick: () => void;
  itemCardRenderType?: SearchItemCardRenderType;
  handleItemCardClick?: (item: Item) => void;
  shouldShowNoResultsPage: boolean;
}

export const SearchResultsPresentation = ({
  proposals,
  items,
  loading,
  totalCount,
  searchQuery,
  setSearchQuery,
  setSearchHistory,
  searchHistory,
  itemCardRenderType = SearchItemCardRenderType.link,
  handleItemCardClick = () => {},
  handleLoadMoreClick,
  shouldShowNoResultsPage,
}: SearchResultsPresentationProps) => {
  const showProposals = proposals.length > 0;
  const showItems = items.length > 0;
  const showLoadMore = totalCount > items?.length;
  const showNoResults = proposals.length < 1 && items.length < 1;
  return (
    <div id="items-search-results">
      {(showItems || showProposals) && <SearchResultsTitle />}
      {showProposals && (
        <SearchProposals
          proposals={proposals}
          searchQuery={searchQuery}
          showProposals={showProposals}
          setSearchQuery={setSearchQuery}
          setSearchHistory={setSearchHistory}
          searchHistory={searchHistory}
        />
      )}
      {showItems && (
        <SearchResultsListView
          itemCardRenderType={itemCardRenderType}
          handleItemCardClick={handleItemCardClick}
          items={items}
        />
      )}
      {showLoadMore && (
        <LoadMore
          totalCount={totalCount}
          loadedItemsCount={items.length}
          onLoadMoreClick={handleLoadMoreClick}
          isFetching={loading}
        />
      )}
      {(showNoResults || shouldShowNoResultsPage) && (
        <SearchNoResults searchQuery={searchQuery} />
      )}
    </div>
  );
};
